// extracted by css-extract-rspack-plugin
export default {"title":"_98452043","subtitle":"_b175c027"};